import React from 'react';
import enhance from './enhance';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import styles from './styles.module.scss';
import ToggleButton from './ToggleButton';

export const AdvancedChart = ({
  currentPresoldQuantity,
  currentStockQuantity,
  data,
  presoldFilterStyle,
  presoldLabel,
  presoldColor,
  stockColor,
  showPresold,
  showStock,
  stockFilterStyle,
  stockLabel,
  togglePresold,
  toggleStock,
  priceBands,
  optionCodes,
  paintOptions,
  interiorOptions,
  modelId,
  clearFiltersLabel,
  resetFilters,
}) => (
  <div className={styles.advancedChart}>
    <ResponsiveContainer
      width="100%"
      height="85%"
      minHeight="175px"
      maxHeight="262px"
    >
      <BarChart
        width={600}
        height={300}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
        <YAxis allowDecimals={false} />
        <Tooltip />
        {showPresold && <Bar dataKey="presold" fill={presoldColor} />}
        {showStock && <Bar dataKey="stock" fill={stockColor} />}
      </BarChart>
    </ResponsiveContainer>
    <div className={styles.filterContainer}>
      <div className={styles.filterTop}>
        <button onClick={togglePresold} className={presoldFilterStyle}>
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: presoldColor,
                strokeWidth: 3,
                stroke: presoldColor,
              }}
            />
          </svg>
          {presoldLabel} ({currentPresoldQuantity})
        </button>
        <button onClick={toggleStock} className={stockFilterStyle}>
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{ fill: stockColor, strokeWidth: 3, stroke: stockColor }}
            />
          </svg>
          {stockLabel} ({currentStockQuantity})
        </button>
      </div>
      <span className={styles.clearFilters} onClick={resetFilters}>
        {clearFiltersLabel}
      </span>
    </div>
    <div className={styles.filterContainer}>
      <div className={styles.filterSection}>
        <span className={styles.sectionHeader}>Price Bands</span>
        {priceBands &&
          priceBands.map(priceBand => (
            <ToggleButton
              key={priceBand.id}
              text={priceBand.priceRange}
              code={priceBand.id}
              count={priceBand.count}
              filterType="priceBands"
              modelId={modelId}
            />
          ))}
      </div>
      <div className={styles.filterSectionLarge}>
        <span className={styles.sectionHeader}>Option Codes</span>
        <div className={styles.filterWithWrap}>
          {optionCodes &&
            optionCodes.map(optionCode => (
              <ToggleButton
                key={optionCode.featureCode}
                text={optionCode.featureCode}
                code={optionCode.featureCode}
                count={optionCode.count}
                description={optionCode.description}
                filterType="functionalOptions"
                modelId={modelId}
              />
            ))}
        </div>
      </div>
      <div className={styles.filterSection}>
        <span className={styles.sectionHeader}>Exterior</span>
        {paintOptions &&
          paintOptions.map(paintOption => (
            <ToggleButton
              key={paintOption.featureCode}
              text={paintOption.featureCode}
              code={paintOption.featureCode}
              count={paintOption.count}
              description={paintOption.description}
              filterType="paintOptions"
              imgIcon={paintOption.iconImgUrl}
              modelId={modelId}
            />
          ))}
      </div>
      <div className={styles.filterSection}>
        <span className={styles.sectionHeader}>Interior</span>
        {interiorOptions &&
          interiorOptions.map(interiorOption => (
            <ToggleButton
              key={interiorOption.featureCode}
              text={interiorOption.featureCode}
              code={interiorOption.featureCode}
              count={interiorOption.count}
              description={interiorOption.description}
              filterType="interiorOptions"
              imgIcon={interiorOption.iconImgUrl}
              modelId={modelId}
            />
          ))}
      </div>
    </div>
  </div>
);

export default enhance(AdvancedChart);
